/**
 * After a new deploy, cached index/main may still reference old hashed lazy chunks → ChunkLoadError.
 * One guarded reload fetches fresh index.html (no-cache) and new chunk names.
 */
const CHUNK_RELOAD_FLAG = 'zt_chunk_autoreload_once';

export function installChunkLoadRecovery(): void {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined') {
    return;
  }
  window.addEventListener('unhandledrejection', (event: PromiseRejectionEvent) => {
    const reason = event.reason;
    const message = typeof reason?.message === 'string' ? reason.message : String(reason ?? '');
    const isChunkLoad =
      reason?.name === 'ChunkLoadError' ||
      /ChunkLoadError/i.test(message) ||
      /Loading chunk [\d]+ failed/i.test(message);
    if (!isChunkLoad) {
      return;
    }
    event.preventDefault();
    if (sessionStorage.getItem(CHUNK_RELOAD_FLAG)) {
      return;
    }
    sessionStorage.setItem(CHUNK_RELOAD_FLAG, '1');
    window.location.reload();
  });
}

export function clearChunkLoadRecoveryFlag(): void {
  if (typeof sessionStorage === 'undefined') {
    return;
  }
  sessionStorage.removeItem(CHUNK_RELOAD_FLAG);
}
